/* REACT PACKAGE IMPORTS */
import { useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import PinField from "react-pin-field";

import { Button } from "react-bootstrap";

/* INTERNAL IMPORTS */
import { startSession } from "../Features/Sessions/Actions/SessionsActions";

export default function PinInput({ sessionId, sessionState }) {
  const mounted = useRef(null);

  const pinRef = useRef(null);
  const dispatch = useDispatch();

  const { details } = sessionState;
  const { exid } = details;

  const [pinNum, setPinNum] = useState(null);


  // HANDLER functions
  const handleCompletePin = () => {
    const pinArray = [];
    pinRef.current.inputs.forEach((input) => pinArray.push(input.value));
    const pinNum = pinArray.join("");
    setPinNum(pinNum);
  };

  const handleClearPin = () => {
	setPinNum(null);
    Array.from(pinRef.current.children).forEach((input) => {
      input.value = "";
    });
  };

  const handleSubmitPin = () => {
    dispatch(startSession({ esId: sessionId, exId: exid, pin: pinNum }));
    setPinNum(null);
    Array.from(pinRef.current.children).forEach((input) => {
      input.value = "";
    });
  };

  useEffect(() => {
    mounted.current = true;
    if (pinRef.current) {
      pinRef.current.inputs[0].focus();
    }
    return () => (mounted.current = false);
  });

  return (
    <div className="">
      <PinField
        autoComplete="one-time-code"
        ref={pinRef}
        length={6}
        onComplete={handleCompletePin}
        validate="0123456789"
        inputMode="numeric"
        className="pin-field"
      />
	  <div onClick={handleClearPin} className="underline text-sm mx-1">Clear PIN Field</div>
      <div className="w-full mt-4">
        <Button
          className="px-5 py-2 inter w-full"
          variant="dark"
          onClick={handleSubmitPin}
        >
          Start Assessment
        </Button>
      </div>
    </div>
  );
}
